const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:90';
import { apiFetch } from '../api';

// export const UploadImagesAPI = async (formData) => {
//     // Do NOT set Content-Type here — the browser must auto-set
//     // "multipart/form-data; boundary=..." for FormData to work correctly.
//     const res = await fetch(`${BASE_URL}/FileUpload/UploadImages`, {
//         method: 'POST',
//         body: formData
//     });

//     if (!res.ok) {
//         let errorMessage = 'Upload failed';
//         try {
//             const body = await res.json();
//             errorMessage = body?.message || errorMessage;
//         } catch (_) { }
//         throw new Error(errorMessage);
//     }

//     return res.json();
// };

export const UploadImagesAPI = (formDate) => {
    return apiFetch(`/FileUpload/UploadImages`, {
        method: 'POST',
        body: formDate
    }, false);
};
